<script lang="ts">
  import { _ } from 'svelte-i18n';

  import FoundingFilters from '$lib/components/FoundingFilters.svelte';
  import { scheduleCount } from '$lib/stores/guided';
  import { foundingYearRange } from '$lib/stores/selection';

  /**
   * When the company was founded.
   *
   * This was a "founded after" number box inside the size step. The sidebar has
   * a two-ended range for the same field, so the guide was offering less than
   * the panel it hands over to — and a customer who set a year here saw a
   * different control afterwards.
   *
   * The component keeps its own checkbox: turning the filter on writes a range,
   * and any range excludes companies whose founding year is unknown. On an
   * optional step that has to stay a deliberate act.
   */
  $: void ($foundingYearRange, scheduleCount());
</script>

<div class="space-y-4">
  <FoundingFilters embedded />

  <p class="text-xs text-gray-500">{$_('guided.founding.hint')}</p>
</div>
